import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { assetPrefix } from '../../stv.config'
import styles from './styles'

const vodPlayerPath = `${assetPrefix}/players/vod`

const VODPlayer = ({ contentType = 'episode' }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="VODPlayer" data-testid="vod-player-container">
      <iframe
        className="vod-iframe"
        data-testid="vod-iframe"
        name="stv-vod-iframe"
        scrolling="no"
        src={`${vodPlayerPath}?contentType=${contentType}`}
        allowFullScreen
        title="vod-player"
      />
      <style jsx>{styles}</style>
    </div>
  )
}
VODPlayer.propTypes = {
  contentType: PropTypes.string,
}

export default VODPlayer
